import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { BuilderComponent } from "@builder.io/react";
import { initializeBuilder } from "@faire/web--source/builder/BuilderComponents/initializeBuilder";
import { useBuilderContentQuery } from "@faire/web--source/builder/BuilderComponents/useBuilderContentQuery";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { trackClientEvent } from "@faire/web-api--source/trackClientEvent";
import React, { Suspense, useEffect } from "react";
import { getBuilderAPIKey } from "./builderUtils";
var LazyRenderWithBuilder = function(param) {
    var modelName = param.modelName, onViewEvent = param.onViewEvent, data = param.data, targets = param.targets, contentOptions = param.contentOptions;
    var apiKey = getBuilderAPIKey();
    useEffect(function() {
        initializeBuilder(apiKey);
    }, [
        apiKey
    ]);
    var _useBuilderContentQuery = useBuilderContentQuery(modelName, _object_spread({
        userAttributes: targets
    }, contentOptions)), sectionContent = _useBuilderContentQuery.data, isPending = _useBuilderContentQuery.isPending;
    var ref = useDoActionWhenVisible(onViewEvent);
    if (isPending) {
        return /*#__PURE__*/ _jsx(LoadingSkeleton, {
            aspectRatio: "16/9",
            width: "100%"
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        children: /*#__PURE__*/ _jsx(BuilderComponent, {
            context: {
                // follow this guide https://www.builder.io/c/docs/custom-actions#in-builder-adding-an-on-click-event to add onClick event in Builder
                onClick: function(params) {
                    trackClientEvent(params);
                }
            },
            content: sectionContent,
            model: modelName,
            data: data
        })
    });
};
export var RenderWithBuilder = function(props) {
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsx(LazyRenderWithBuilder, _object_spread({}, props))
    });
};
